/** 网络请求 封装 */
import querystring from 'querystring';
import JSEncrypt from './lib/jsencrypt';
import md5 from './lib/md5';

const appName = 'AppH5', edition = 'miyou', version = '1.60.0';
const FETCH_URL = 'https://app.chujijiudai.com/apied/v1/';
const FETCH_URL_TEST = 'http://ttest.chujijiudai.com/apied/v1/';  // TEST
const REQUEST_TIMEOUT = 5000;
const RSA_PUBLIC_KEY = `-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAtVOUkB8AeSXBNsfGMjTSTYY8JEc3QQ0AlEdeHfsVbhgUrCdNvGqTkyNt1RQLmB+grplWo7XDgfX3GffpqKeaZZC/S/SvBL4n1EMJF4+kj7IeKeGquDpg8Jxgi8HeNIyB4Q+HhcArmixmZd2QUKYNKOcDojRjk2W0IMN4xrusuSEFfUf2yqiJ6+y6XHaYfXQgBiErwf1PDJjo1Dye2otzCFb9pU9Fr3i3ND7vccw+YaxAYTwd8el13heeCqZ9QEB37RQEKy+F+RgMtqG7p6U138vxo2HDWcM8MXLHrYr/WY3+opixF5cE+JJnBl7tR8n0QfA9XR/dkv+XZF80POJ1lwIDAQAB
-----END PUBLIC KEY-----`;


function timeout() {
    return new Promise((resolve, reject) => {
        setTimeout(() => {
        }, REQUEST_TIMEOUT);
    });
}

function getApiPrefix() {
    let urlPrefix = FETCH_URL;
    urlPrefix = FETCH_URL_TEST;
    return urlPrefix;
}

/** GET 接口请求 */
function get(url, body, token) {
    const REQUEST_URL = getApiPrefix();
    return new Promise((resolve, reject) => {
        fetch(`${REQUEST_URL + url}?${querystring.stringify(body)}`, {
            credentials: 'include',
            headers: {
                Accept: "application/json",
                Authorization: token,
                "Content-Type": "application/json",
                'edition': edition,
                'version': version,
                'system': 1,
                'appName': appName,
                // 'timestamp': ts,
                // 'noncesign': nonce,
            },
            method: 'get'
        }).then(response => response.json()).then(res => {
            apiCallBackProcessing(res, resolve, reject, url);
        }).catch(err => {
            const params = {};
            params.error = 'NETWORK_ERROR';
            params.message = JSON.stringify(err);
            apiCallBackProcessing(params, resolve, reject, url);
        });
    })
}

/** POST 接口请求 */
function post(url, body) {
    // const REQUEST_URL = Consts.isDev ? FETCH_URL_TEST : FETCH_URL;
    const REQUEST_URL = getApiPrefix();
    return new Promise((resolve, reject) => {
        if (body) {
            const md5Str = md5(JSON.stringify(body ? body : {}));
            const temp = new JSEncrypt();
            temp.setPublicKey(RSA_PUBLIC_KEY);
            const sign = temp.encrypt(md5Str);
            body.sign = sign;
        }
        fetch(REQUEST_URL + url, {
            credentials: 'include',
            headers: {
                Accept: "application/json",
                Authorization: global.FETCH_USER_TOKEN,
                "Content-Type": "application/json",
                'edition': edition,
                'version': version,
                'appName': appName,
                'system': 1
            },
            method: 'post',
            body: JSON.stringify(body),
        }).then(response => response.json()).then(res => {
            apiCallBackProcessing(res, resolve, reject, url);
        }).catch(err => {
            const params = {};
            params.error = 'NETWORK_ERROR';
            params.message = JSON.stringify(err);
            apiCallBackProcessing(params, resolve, reject, url);
        });
    })
}


function parseJSON(responseData) {
    const { _bodyInit, _bodyText } = responseData ? responseData : "";
    if (_bodyInit && _bodyText) return JSON.parse(_bodyText);
    return {};
}

/** 接口回调数据统一处理 */
function apiCallBackProcessing(res, resolve, reject, url = '') {
    // if (url == 'chat/finishck')
    console.log('login invaliad si - - - - - >', url, res);
    // return;
    if (res && res.status && res.status == 200) {
        resolve(res.data);
    } else if (res && res.status && res.status == -200) {
        if(res.message) {
            const { seconds = 3 } = res;
            alert(res.message);
        }
        reject(false);
    } else if (res && res.status && (res.status == -300 || res.status == -3000)) {
        /** 账号 已在其他地方登录 */
        alert(res.message);
    } else if (res && res.status && (res.status == -600 || res.status == -2000)) {
        // const params = {};
        // params.message = res.message;
        // params.errorCode = ERROR_NO_MONEY;
        // resolve(params);
        alert('用户余额不足')
        resolve(false);
    } else if (res && res.error && res.error == 'NETWORK_ERROR') {
        // if (!REQUEST_FAILED_SHOWN) { // 网络情况不好时 提示一次
        //     Consts.REQUEST_FAILED_SHOWN = true;
        //     LoadingUtil.showLoading('网络开了会小差，请稍后再试!', 5, true);
        // }
        alert(`网络错误<url> --->` + JSON.stringify(res.message));
        reject(false);
    } else {
        // LoadingUtil.showLoading(`服务器繁忙，请稍后重试`, 3, true);
        // LoadingUtil.showLoading(`服务器繁忙，请稍后重试<${url}>`, 3, true);
        alert(`服务器错误<${url}> -->` + JSON.stringify(res));
        reject(false);
    }
}

export default class Request {
    /** 通用 GET 请求 */
    static get(url, body, token) {
        return new Promise((resolve, reject) => {
            Promise.race([get(url, body, token), timeout()]).then(responseData => {
                resolve(responseData);
            }).catch(err => {
                // alert(err);
                reject(err);
            })
        })
    }

    /** 通用 POST 请求 */
    static post(url, body, token) {
        return new Promise((resolve, reject) => {
            Promise.race([post(url, body, token), timeout()]).then(responseData => {
                resolve(responseData);
            }).catch(err => {
                reject(err);
            });

            // if (!global.requestArrPost || !global.requestArrPost[`${url}`]) {   // 方式post 接口重复提交
            //     global.requestArrPost[`${url}`] = true;
            //     Promise.race([post(url, body, token), timeout()]).then(responseData => {
            //         global.requestArrPost[`${url}`] = false;
            //         resolve(responseData);
            //     }).catch(err => {
            //         global.requestArrPost[`${url}`] = false;
            //         reject(err);
            //     });
            // }
        })
    }
}